import { render } from "./RecipientDashboard.vue?vue&type=template&id=80e7fe06&scoped=true"
import script from "./RecipientDashboard.vue?vue&type=script&lang=js"
export * from "./RecipientDashboard.vue?vue&type=script&lang=js"

import "./RecipientDashboard.vue?vue&type=style&index=0&id=80e7fe06&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e7fe06"]])

export default __exports__